import api from '../../services/api';

/**
 * The warehouses this session reaches, each with its active clients and with
 * `can_manage` — whether the session holds that space.
 * `can_reserve` — whether it may reserve orders there: whoever prepares, and
 * the client its contract lets reserve (`seller_can_reserve`).
 *
 * Not `warehouses/` (staff only) nor `warehouses/all_warehouses/` (filters by
 * the company that owns the space, which a distribution centre does not have).
 */
export const getScopedWarehousesRequest = async () => {
  return await api.get('warehouses/scoped/');
};
